export const GET_LOGS = "GET_LOGS";
export const DELETE_LOGS = "DELETE_LOGS";
export const LOGS_ERROR = "LOGS_ERROR";
